import {useOpenedStateManager} from '@aboutyou/opened-state-manager';
import {useQuickFilterSectionAttributeOpenedState} from './useQuickFilterSectionAttributeOpenedState';
import {useQuickFilterSectionBrandOpenedState} from './useQuickFilterSectionBrandOpenedState';
import {useQuickFilterSectionBrandSearchOpenedState} from './useQuickFilterSectionBrandSearchOpenedState';
import {useQuickFilterSectionColorOpenedState} from './useQuickFilterSectionColorOpenedState';
import {useQuickFilterSectionDiscountOpenedState} from './useQuickFilterSectionDiscountOpenedState';
import {useQuickFilterSectionMaterialOpenedState} from './useQuickFilterSectionMaterialOpenedState';
import {useQuickFilterSectionPriceOpenedState} from './useQuickFilterSectionPriceOpenedState';
import {useQuickFilterSectionSizeGroupedOpenedState} from './useQuickFilterSectionSizeGroupedOpenedState';
import {useQuickFilterSectionSizeSimpleOpenedState} from './useQuickFilterSectionSizeSimpleOpenedState';

/**
 * It checks if any quick filter flyout or regular flyout filter is open

 * @returns {boolean} - Whatever a flyout filter is opened or not
 */
export const useAnyFilterFlyoutOpened = () => {
  const {isOpen: isFilterOpen} = useOpenedStateManager('filter');
  const {isOpen: isQuickFilterAttributeOpen} =
    useQuickFilterSectionAttributeOpenedState();
  const {isOpen: isQuickFilterBrandOpen} =
    useQuickFilterSectionBrandOpenedState();
  const {isOpen: isQuickFilterBrandSearchOpen} =
    useQuickFilterSectionBrandSearchOpenedState();
  const {isOpen: isQuickFilterColorOpen} =
    useQuickFilterSectionColorOpenedState();
  const {isOpen: isQuickFilterDiscountOpen} =
    useQuickFilterSectionDiscountOpenedState();
  const {isOpen: isQuickFilterMaterialOpen} =
    useQuickFilterSectionMaterialOpenedState();
  const {isOpen: isQuickFilterPriceOpen} =
    useQuickFilterSectionPriceOpenedState();
  const {isOpen: isQuickFilterSizeGroupedOpen} =
    useQuickFilterSectionSizeGroupedOpenedState();
  const {isOpen: isQuickFilterSizeSimpleOpen} =
    useQuickFilterSectionSizeSimpleOpenedState();

  return (
    isFilterOpen ||
    isQuickFilterAttributeOpen ||
    isQuickFilterBrandOpen ||
    isQuickFilterBrandSearchOpen ||
    isQuickFilterColorOpen ||
    isQuickFilterDiscountOpen ||
    isQuickFilterMaterialOpen ||
    isQuickFilterPriceOpen ||
    isQuickFilterSizeGroupedOpen ||
    isQuickFilterSizeSimpleOpen
  );
};
